import crypto from 'crypto-browserify';
export default crypto;
